import { jsxs as v, jsx as s } from "react/jsx-runtime";
import { I } from "../chunks/index.ed48ee81.js";
import { g as z } from "../chunks/generate-random-id.f7e64105.js";
import { m as B } from "../chunks/make-refs.cb0b9b76.js";
import { forwardRef as F, useState as G, useEffect as H } from "react";
import { c as J, g as K, s as l } from "../chunks/common.cbb2911d.js";
const W = F(
  ({
    "aria-controls": u,
    "aria-haspopup": g,
    "aria-label": o,
    a11yControls: b,
    a11yHasPopup: x = "listbox",
    a11yLabel: r,
    a11yTitle: N,
    className: y,
    color: c,
    disabled: j,
    icon: n,
    intent: a = "default",
    isActive: i = !1,
    isDisabled: C = !1,
    isSelected: e = !1,
    label: p,
    onClick: t,
    title: R,
    ...S
  }, $) => {
    const { $el: w } = B($, ["$el"]), [m, d] = G(e), f = z("chip");
    H(() => {
      d(e);
    }, [e]);
    const D = (q) => {
      a === "default" && d(!m), t == null || t(q);
    }, E = J({
      className: y,
      intent: a,
      isActive: i,
      isSelected: m
    }), { trailingIcon: h, trailingIconClass: T } = K(a);
    return /* @__PURE__ */ v(
      "button",
      {
        "aria-label": o || r,
        "aria-labelledby": !o || !r ? f : void 0,
        className: E,
        disabled: j || C,
        onClick: D,
        ref: w,
        title: R || N,
        type: "button",
        ...a === "expandable" && {
          "aria-controls": u || b,
          "aria-expanded": i,
          "aria-haspopup": g || x
        },
        ...S,
        children: [
          n && /* @__PURE__ */ s(I, { className: l.leadingIcon, icon: n }),
          c && /* @__PURE__ */ s(
            "span",
            {
              className: l.colorContent,
              style: { "--chip-color": c }
            }
          ),
          /* @__PURE__ */ s("span", { className: l.label, "data-phantom-text": p, id: f, children: p }),
          h && /* @__PURE__ */ s(I, { className: T, icon: h })
        ]
      }
    );
  }
);
export {
  W as Chip
};
//# sourceMappingURL=Chip.js.map
